import { render, staticRenderFns } from "./NextService.vue?vue&type=template&id=60ecac75&scoped=true"
import script from "./NextService.vue?vue&type=script&lang=js"
export * from "./NextService.vue?vue&type=script&lang=js"
import style0 from "./NextService.vue?vue&type=style&index=0&id=60ecac75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ecac75",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/vercel/path0/components/elements/Link.vue').default,Medias: require('/vercel/path0/components/elements/Medias/index.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
